export const CONCIL_LIST = {
  MEDICO: 'CRM',
  NUTRICIONISTA: 'CRN',
  ENFERMEIRO: 'COREN',
  PSICOLOGO: 'CRP',
  ASSISTENTE_SOCIAL: 'CFESS',
  DENTISTA: 'CRO',
  FISIOTERAPEUTA: 'CREFITO',
  FONOAUDIOLOGO: 'CREFONO',
  EDUCADOR_FISICO: 'CREF',
}
